<template>
  <page-container>
    <tab-buttons :modelValue="selected" :items="items" @change="onTabSelected" />
    <router-view />
  </page-container>
</template>

<script setup>
import { findLast } from 'lodash-es';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

import { hasRoutePermission } from '@/router/utils';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const selected = computed(() => {
  return findLast(route.matched, (r) => r.meta?.tab)?.name;
});

const items = computed(() => {
  const menuRoute = findLast(route.matched, (r) => r.meta?.menu);
  if (!menuRoute?.children) return [];

  return (
    menuRoute.children
      .filter((r) => r.meta?.tab && hasRoutePermission(r))
      // 导航多语言设置
      .map((r) => ({ value: r.name, title: r.meta.langKey ? t(r.meta.langKey) : '' }))
  );
});

const onTabSelected = (value) => {
  if (value === selected.value) return;

  const menuRoute = findLast(route.matched, (r) => r.meta?.menu);
  if (menuRoute?.meta?.replaceTabHistory) {
    // 移动端返回要直接退出模块时，tab 切换不写入历史栈。
    router.replace({ name: value });
    return;
  }

  router.push({ name: value });
};
</script>
